"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Form = _interopRequireDefault(require("./Form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  var responseDialog = {
    open: false,
    success: false,
    errorCode: '',
    errorMessage: 'Hubo un error!'
  };
  var response = {
    successTitle: 'Correcto, Bien hecho!',
    successLabel: 'Aceptar',
    successMessage: 'Es una buena prueba',
    errorTitle: 'Hubo un error!',
    errorMessage: 'Mensaje de error'
  };
  return /*#__PURE__*/_react.default.createElement(_Form.default, _extends({}, props, {
    responseDialog: responseDialog,
    response: response,
    successPath: "."
  }));
};

exports.default = _default;